// Dependencies
import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import DiplomaView from 'views/DiplomaView';

import {
  BackImage,
  CheckLogin,
  CollectionView,
  ContactView,
  DirectoryView,
  FastFactsView,
  FavoriteView,
  Header,
  HomeView,
  MessageCenter,
  MobileWarning,
  NotFoundView,
  NotLoggedInView,
  RetainContentView,
  RetainView,
  RewardsView,
  Search,
  SubAppView,
  ToolboxView,
  TrainingContentView,
  TrainingView,
  WebsiteSplitter,
} from 'C4';

const loginPages = ['training', 'retain', 'diploma'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route path="/main" exact render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (pathname.includes('main/training/chapter/')) {
          return null;
        }
        if (pathname.includes('main/fasttrack/chapter/')) {
          return null;
        }
        return <Header pathname={pathname} />;
      }}
    />
    <div className="viewContainer">
      <BackImage />
      <Switch>
        <Route path="/main" exact component={HomeView} />
        <Route path="/main/landing" exact component={HomeView} />
        <Route path="/main/mob" exact component={MobileWarning} />
        <Route path="/main/contact" exact component={ContactView} />
        <Route path="/main/sell/contact" exact component={ContactView} />
        <Route path="/main/training" exact component={TrainingView} />
        <Route path="/main/diploma" exact component={DiplomaView} />
        <Route path="/main/ret" exact component={RetainView} />
        <Route path="/main/ret/chapter" exact render={() => <Redirect to="/main/ret" />} />
        <Route path="/main/retain" exact component={RetainView} />
        <Route path="/main/ret/chapter/:chapterId/:pageId" exact component={RetainContentView} />
        <Route
          path="/main/:pageType/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case 'ret':
                return <RetainContentView key={pageId} {...props} />;
              case 'training':
              case 'fasttrack':
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route path="/main/favorites" exact component={FavoriteView} />
        <Route path="/main/promote" exact component={FastFactsView} />
        <Route path="/main/sell" exact component={ToolboxView} />
        <Route path="/main/subApp" exact component={SubAppView} />
        <Route path="/main/directory" exact component={DirectoryView} />
        <Route path="/main/messages" exact component={MessageCenter} />
        <Route path="/main/rewards" exact component={RewardsView} />
        <Route path="/main/landing/messages" exact component={MessageCenter} />
        <Route path="/main/promote/videos/:videoId?" component={CollectionView} />
        <Route path="/main/promote/images/:imageId?" component={CollectionView} />
        <Route path="/main/sell/videoLibrary/:videoId?" component={CollectionView} />
        <Route path="/main/sell/imageLibrary/:imageId?" component={CollectionView} />
        <Route path="/main/promote/guides/:brochureId?" component={CollectionView} />
        <Route path="/main/sell/ships/:brochureId?" component={CollectionView} />
        <Route path="/main/promote/special-itineraries/:brochureId?" component={CollectionView} />
        <Route path="/main/promote/expeditions/:brochureId?" component={CollectionView} />
        <Route path="/main/sell/current-offers/" component={CollectionView} />
        <Route path="/main/sell/current-promotions/" component={CollectionView} />
        <Route path="/main/search" component={Search} />
        <Route
          path="/main/promote/antarctic-images/:colId"
          render={props => <CollectionView key={props.match.params.colId}{...props} /> }
        />
        <Route
          path="/main/promote/arctic-images/:colId"
          render={props => <CollectionView key={props.match.params.colId}{...props} /> }
        />
        <Route
          path="/main/promote/social-media/:colId"
          render={props => <CollectionView key={props.match.params.colId}{...props} /> }
        />
        <Route
          path="/main/promote/brochures/:colId"
          render={props => <CollectionView key={props.match.params.colId}{...props} /> }
        />
        <Route
          path="/main/promote/unique-experiences/:colId"
          render={props => <CollectionView key={props.match.params.colId}{...props} /> }
        />
        <Route
          path="/main/(sell|promote)/:category/:item?" 
          render={props => <CollectionView key={props.match.params.category}{...props} /> }
        />

        <Route path="/main/off" component={NotLoggedInView} />
        <Route
          path="special-error-route"
          render={() => {
            throw new Error('Testing Sentry');
          }}
        />
        <Route path="/main/splitter/:itemId/:type" component={WebsiteSplitter} />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
